import Router from 'next/router'

const pushRoute = async ({ href, as }) => await Router.push(href, as)

export default pushRoute
